export default __webpack_public_path__ + "static/media/j17.cb13917b.jpg";